/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Local logic module constants
 */

export const LOADING_POI = '@@nzr/poi/LOADING_POI'
export const LOADED_POI_FOR = '@@nzr/poi/LOADED_POI_FOR'
export const RECEIVE_LOCATION_SCORES = '@@nzr/poi/RECEIVE_LOCATION_SCORES'
export const RECEIVE_LOCATION_POIS = '@@nzr/poi/RECEIVE_LOCATION_POIS'
export const SET_POI_LOCATION = '@@nzr/poi/SET_POI_LOCATION'
